var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleExclamationRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.864 14 14 10.864 14 7C14 3.136 10.864 -2.74158e-07 7 -6.11959e-07C3.136 -9.49761e-07 9.49761e-07 3.136 6.11959e-07 7C2.74158e-07 10.864 3.136 14 7 14ZM6.3 3.5L7.7 3.5L7.7 7.7L6.3 7.7L6.3 3.5ZM6.3 9.1L7.7 9.1L7.7 10.5L6.3 10.5L6.3 9.1Z",
    fill: "#EC6661"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamationRed);
export default __webpack_public_path__ + "static/media/circle-exclamation-red.96e66f3728852b18226eea15c965b5eb.svg";
export { ForwardRef as ReactComponent };